<template>
  <div class="min-vh">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SETTING TIME</h1>
      <button class="create-button" @click="onEdit()">
        <div>
          <font-awesome-icon icon="plus-square" />
          <span class="ml-2"> CREATE</span>
        </div>
      </button>
      <ModalCreateOrEditTime
        ref="createEditTimeModal"
        :form="form"
        :dateLists="dateLists"
        :onSubmit="onSubmit"
        :v="$v"
      />
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="details"
        :fields="fields"
        :busy="isBusy"
        show-empty
        empty-text="ไม่พบข้อมูล"
        :current-page="filter.pageNo"
        :per-page="filter.perPage"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(startTime)="data">
          <span>{{
            `${data.item.startTime.substring(0, 5)}${
              language == "th" ? "น." : ""
            }`
          }}</span>
        </template>
        <template v-slot:cell(endTime)="data">
          <span>{{
            `${data.item.endTime.substring(0, 5)}${
              language == "th" ? "น." : ""
            }`
          }}</span>
        </template>
        <template v-slot:cell(active)="data">
          <span v-if="data.item.active" class="text-success">Active</span>
          <span v-else class="text-danger">Inactive</span>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link class="text-link" @click="onEdit(data.item)">
              <font-awesome-icon
                icon="pencil-alt"
                class="text-warning"
                title="Edit"
              />
            </b-link>
            <b-link class="text-link ml-3" @click="onDeleteModal(data.item)">
              <font-awesome-icon
                icon="trash-alt"
                class="text-danger"
                title="Delete"
              />
            </b-link>
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to
            {{ endPage | numeral("0,0") }} of
            {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalCreateOrEditTime from "./component/ModalCreateOrEditTime.vue";
import moment from "moment";
import { required, minValue } from "vuelidate/lib/validators";
export default {
  name: "SettingTime",
  components: {
    ModalAlertConfirm,
    ModalCreateOrEditTime,
  },
  data: function () {
    return {
      modalMessage: "",
      requestIdDelete: null,
      form: {
        name: "",
        id: 0,
        dayId: 0,
        brandId: this.$route.query.brandID,
        startTime: "",
        endTime: "",
        active: true,
      },
      rows: 0,
      isBusy: false,
      dateLists: [],
      fields: [
        {
          key: "name",
          label: this.$t("businessDay"),
          class: "w-100px",
        },
        {
          key: "startTime",
          label: this.$t("openTime"),
          class: "w-100px",
        },
        {
          key: "endTime",
          label: this.$t("closeTime"),
          class: "w-100px",
        },
        {
          key: "active",
          label: this.$t("status"),
          class: "w-100px",
        },
        {
          key: "id",
          label: "",
          class: "w-action",
        },
      ],
      details: [],
      filter: {
        pageNo: 1,
        perPage: 10,
      },
      startPage: 1,
      endPage: 10,
      language: this.$store.state.language,
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      dayId: {
        required,
        minValue: minValue(1),
      },
      startTime: {
        required,
      },
      endTime: {
        required,
      },
      active: {
        required,
      },
    },
  },
  created: async function () {
    this.getDateList();
    await this.getSettingTime();
  },
  methods: {
    getSettingTime: async function () {
      this.isBusy = true;
      const url = `${this.$baseUrl}/BusinessHour`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          this.details = data.detail;
          this.rows = data.detail.length;
          this.isBusy = false;
        }
      });
    },
    getDateList: async function () {
      const url = `${this.$baseUrl}/BusinessHour/day`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          let list = [{ id: 0, name: "Please Select" }];
          this.dateLists = list.concat(data.detail);
        }
      });
    },
    onEdit(data) {
      this.setForm(data);
      this.$v.$reset();
      this.$refs.createEditTimeModal.showModal = true;
    },
    onDeleteModal(data) {
      this.requestIdDelete = data.id;
      this.modalMessage = `คุณต้องการลบ ${data.name} เวลา ${data.startTime} - ${data.endTime} ใช่หรือไม่?`;
      this.$refs.ModalAlertConfirm.show();
    },
    setForm(data) {
      if (data) {
        this.form = { ...data };
      } else {
        this.form = {
          name: "",
          id: 0,
          dayId: 0,
          brandId: this.$route.query.brandID,
          startTime: "",
          endTime: "",
          active: true,
        };
      }
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$error) {
        return;
      }
      this.form.startTime = moment(this.form.startTime).format("HH:mm:ss");
      this.form.endTime = moment(this.form.endTime).format("HH:mm:ss");
      const saveUrl = `${this.$baseUrl}/BusinessHour/`;
      await this.axios
        .post(saveUrl, this.form)
        .then(async (data) => {
          if (data.result == 1) {
            this.$refs.createEditTimeModal.showModal = false;
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.getSettingTime();
          } else {
            this.$refs.createEditTimeModal.showModal = false;
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$refs.createEditTimeModal.showModal = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      const id = this.requestIdDelete;
      const deleteUrl = `${this.$baseUrl}/BusinessHour/${id}`;
      await this.axios.delete(deleteUrl).then(async (data) => {
        if (data.result == 1) {
          this.$store.commit("UPDATE_GLOBAL_ALERT", {
            isShow: true,
            msg: data.message,
          });
          await this.getSettingTime();
        } else {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: data.message,
          });
        }
      });
    },
    async pagination(Page) {
      this.filter.pageNo = Page;
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
  },
};
</script>
